module.exports = __webpack_public_path__ + "img/flag-icon-fr.63d32e7b.png";